import { render, staticRenderFns } from "./componentes.vue?vue&type=template&id=5d18c8c7&scoped=true&"
import script from "./componentes.vue?vue&type=script&lang=js&"
export * from "./componentes.vue?vue&type=script&lang=js&"
import style0 from "./componentes.vue?vue&type=style&index=0&id=5d18c8c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18c8c7",
  null
  
)

export default component.exports